<script lang="ts">
  import { session, currentStep, records, selectedChecklistId } from '../stores';
  import { checklists } from '../data/checklists';
  import type { RoleType, UserSession } from '../types';
  import { ROLE_LABELS } from '../types';

  let selectedRole: RoleType | null = null;
  let staffName: string = '';
  let showRoleSelect = true;

  // 把管委放到最後
  const roles: RoleType[] = ['day', 'night', 'committee'];

  function selectRole(role: RoleType) {
    selectedRole = role;
    showRoleSelect = false;
  }

  function goBack() {
    showRoleSelect = true;
    selectedRole = null;
    staffName = '';
  }

  function selectChecklist(checklistId: string) {
    if (!selectedRole) return;

    const newSession: UserSession = {
      role: selectedRole,
      name: staffName || ROLE_LABELS[selectedRole],
      startTime: new Date().toISOString()
    };

    session.set(newSession);
    selectedChecklistId.set(checklistId);
    records.set({});
    currentStep.set('checklist');
  }
</script>

<div class="w-full max-w-2xl mx-auto px-2">
  {#if showRoleSelect}
    <div class="text-center mb-8">
      <h2 class="text-3xl sm:text-4xl font-bold text-gray-800 mb-3">選擇您的角色</h2>
      <p class="text-gray-600 text-xl sm:text-2xl">請點選您目前擔任的職位</p>
    </div>

    <div class="grid grid-cols-2 gap-4 sm:gap-6 mb-8">
      {#each roles as role (role)}
        <button
          on:click={() => selectRole(role)}
          class="p-6 sm:p-10 bg-linear-to-br rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 text-center font-bold text-white text-xl sm:text-3xl leading-tight"
          class:from-blue-500={role === 'committee'}
          class:to-blue-600={role === 'committee'}
          class:from-amber-500={role === 'day'}
          class:to-amber-600={role === 'day'}
          class:from-purple-500={role === 'night'}
          class:to-purple-600={role === 'night'}
        >
          {ROLE_LABELS[role]}
        </button>
      {/each}
    </div>
  {:else if selectedRole}
    <div class="mb-8">
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-3xl sm:text-4xl font-bold text-gray-800">
          {ROLE_LABELS[selectedRole]}
        </h2>
        <button
          on:click={goBack}
          class="px-4 sm:px-6 py-3 sm:py-4 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold rounded-lg text-xl sm:text-2xl"
        >
          ◀ 返回
        </button>
      </div>

      <div class="mb-8 p-5 bg-blue-50 rounded-2xl border-l-4 border-blue-500">
        <label for="staff-name" class="text-xl sm:text-2xl font-semibold text-gray-700 block mb-3">
          稱呼（可選）
        </label>
        <input
          id="staff-name"
          type="text"
          bind:value={staffName}
          placeholder={ROLE_LABELS[selectedRole]}
          class="w-full px-4 py-4 text-xl sm:text-2xl border-2 border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
        />
      </div>

      <div class="space-y-4">
        {#each checklists as checklist (checklist.id)}
          {@const roles = Array.isArray(checklist.role) ? checklist.role : [checklist.role]}
          {#if roles.includes(selectedRole) || selectedRole === 'committee'}
            <button
              on:click={() => selectChecklist(checklist.id)}
              class="w-full p-6 sm:p-8 bg-linear-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 border-2 border-blue-300 rounded-2xl transition-all duration-300 text-left active:scale-95"
            >
              <div class="text-2xl sm:text-3xl font-bold text-blue-700">
                {checklist.title}
              </div>
              <div class="text-gray-600 text-lg sm:text-xl mt-2">
                {checklist.items.length} 個檢查項目
              </div>
            </button>
          {/if}
        {/each}
      </div>
    </div>
  {/if}
</div>
